export type NewArrival = {
  id: number;
  title: string;
  brand: string;
  series: string;
  scale: string;
  price: string;
  date: string;
  status: "现货" | "预售" | "预订" | "限量";
  heat: number;
};

export const newArrivals: NewArrival[] = [
  {
    id: 1,
    title: "初音未来 交响乐 Ver. 1/7 手办",
    brand: "GSC 良笑社",
    series: "VOCALOID",
    scale: "1:7",
    price: "¥1,280",
    date: "09-25",
    status: "现货",
    heat: 98,
  },
  {
    id: 2,
    title: "灶门炭治郎 火之神神乐 1/7 手办",
    brand: "万代",
    series: "鬼灭之刃",
    scale: "1:7",
    price: "¥780",
    date: "09-28",
    status: "预售",
    heat: 93,
  },
  {
    id: 3,
    title: "EVA 初号机 RG 拼装模型",
    brand: "万代",
    series: "新世纪福音战士",
    scale: "1:144",
    price: "¥320",
    date: "09-22",
    status: "现货",
    heat: 95,
  },
  {
    id: 4,
    title: "露娜 FLOWER Ver. 1/6 手办",
    brand: "良笑社",
    series: "原创企划",
    scale: "1:6",
    price: "¥1,580",
    date: "09-20",
    status: "预订",
    heat: 88,
  },
  {
    id: 5,
    title: "高达 PG 独角兽 1/60 拼装模型",
    brand: "万代",
    series: "机动战士高达",
    scale: "1:60",
    price: "¥1,880",
    date: "09-18",
    status: "现货",
    heat: 97,
  },
  {
    id: 6,
    title: "五条悟 战斗 Ver. 1/8 手办",
    brand: "寿屋",
    series: "咒术回战",
    scale: "1:8",
    price: "¥960",
    date: "09-15",
    status: "预售",
    heat: 90,
  },
  {
    id: 7,
    title: "明日方舟 能天使 GK 树脂套件",
    brand: "未定工坊",
    series: "明日方舟",
    scale: "1:7",
    price: "¥2,200",
    date: "09-12",
    status: "限量",
    heat: 84,
  },
  {
    id: 8,
    title: "宝可梦 喷火龙 场景雕像",
    brand: "龙成工作室",
    series: "精灵宝可梦",
    scale: "非比例",
    price: "¥1,360",
    date: "09-10",
    status: "现货",
    heat: 86,
  },
];

export type Review = {
  id: number;
  title: string;
  excerpt: string;
  score: string;
  author: string;
  category: string;
  date: string;
  comments: number;
};

export const reviews: Review[] = [
  {
    id: 1,
    title: "GSC 初音未来 交响乐 Ver. 深度测评：配色还原度极高，支架略软",
    excerpt: "涂装层次和渐变处理在同价位里属于第一梯队，衣摆的珠光漆实物比官图更耐看，唯一要吐槽的是底座支柱偏软，建议加配重。",
    score: "9.2",
    author: "老猫测评",
    category: "手办",
    date: "09-26",
    comments: 128,
  },
  {
    id: 2,
    title: "万代 RG 初号机开箱拼装体验：可动性拉满但贴纸偏多",
    excerpt: "内部骨架分件相当良心，肩甲与腿部关节的可动范围超出预期，缺点是补色贴纸数量不少，素组党需要多准备一把尖头镊子。",
    score: "9.0",
    author: "板砖君",
    category: "拼装模型",
    date: "09-24",
    comments: 96,
  },
  {
    id: 3,
    title: "寿屋 五条悟 战斗 Ver. 值不值得等？预售细节全解析",
    excerpt: "对比上一版无下限形态，这次的动态姿势和特效件诚意更足，价格小幅上浮但不算离谱，冲造型的可以放心预订。",
    score: "8.6",
    author: "手办猎人",
    category: "手办",
    date: "09-22",
    comments: 74,
  },
  {
    id: 4,
    title: "千元档手办怎么挑？5 款良笑社千元级横向对比",
    excerpt: "从涂装、配件、人物还原度到保值率逐项打分，帮你把预算花在刀刃上，新手照着这份清单挑基本不会踩坑。",
    score: "9.4",
    author: "阿澈",
    category: "选购",
    date: "09-19",
    comments: 210,
  },
  {
    id: 5,
    title: "GK 明日方舟能天使上色翻车实录与补救全过程",
    excerpt: "第一次接触树脂 GK，肤色叠色直接翻车，这里把洗件、补土、重新上色的完整补救流程和踩过的坑一次性讲清楚。",
    score: "8.1",
    author: "模型工坊",
    category: "GK",
    date: "09-17",
    comments: 53,
  },
  {
    id: 6,
    title: "PG 独角兽 1:60 拼装全流程与打磨要点",
    excerpt: "从开盒验件到骨架上色，重点记录了几个容易忽略的接缝处理位，配合打磨膏可以做出很接近喷涂的成品效果。",
    score: "8.9",
    author: "板砖君",
    category: "拼装模型",
    date: "09-15",
    comments: 141,
  },
];

export type DatabaseRow = {
  id: number;
  name: string;
  brand: string;
  series: string;
  scale: string;
  release: string;
  score: string;
  votes: number;
};

export const databaseRows: DatabaseRow[] = [
  { id: 1, name: "初音未来 交响乐 Ver.", brand: "GSC 良笑社", series: "VOCALOID", scale: "1:7", release: "2026-09", score: "9.2", votes: 1286 },
  { id: 2, name: "灶门炭治郎 火之神神乐", brand: "万代", series: "鬼灭之刃", scale: "1:7", release: "2026-09", score: "8.8", votes: 942 },
  { id: 3, name: "EVA 初号机 RG", brand: "万代", series: "新世纪福音战士", scale: "1:144", release: "2026-09", score: "9.0", votes: 1530 },
  { id: 4, name: "露娜 FLOWER Ver.", brand: "良笑社", series: "原创企划", scale: "1:6", release: "2026-08", score: "8.7", votes: 664 },
  { id: 5, name: "五条悟 战斗 Ver.", brand: "寿屋", series: "咒术回战", scale: "1:8", release: "2026-09", score: "8.6", votes: 720 },
  { id: 6, name: "高达 PG 独角兽", brand: "万代", series: "机动战士高达", scale: "1:60", release: "2026-09", score: "9.3", votes: 2104 },
];

export type ForumPost = {
  id: number;
  title: string;
  excerpt: string;
  board: string;
  author: string;
  replies: number;
  time: string;
  hot: boolean;
};

export const forumPosts: ForumPost[] = [
  {
    id: 1,
    title: "第一次收手办，预算 1000 以内有什么必入款？",
    excerpt: "刚入坑两个月，主要喜欢羁绊系角色，想问问大家这个预算段有哪些不太会翻车、保值也还行的选择？",
    board: "新手互助",
    author: "小新入坑",
    replies: 86,
    time: "12 分钟前",
    hot: true,
  },
  {
    id: 2,
    title: "晒一下我的初音收藏墙，从 2016 攒到现在",
    excerpt: "陆陆续续收了八年，终于把整面墙填满了，顺手分享几个防尘防氧化的摆放心得，欢迎同好来交流。",
    board: "晒物专区",
    author: "阿澈",
    replies: 132,
    time: "32 分钟前",
    hot: true,
  },
  {
    id: 3,
    title: "求推荐适合新手的拼装工具套装，剪钳到底选哪种？",
    excerpt: "预算有限不想一步到位，想先入手一套够用的入门工具，剪钳、笔刀、打磨棒有没有性价比组合推荐？",
    board: "拼装交流",
    author: "板砖君",
    replies: 48,
    time: "1 小时前",
    hot: false,
  },
  {
    id: 4,
    title: "寿屋五条悟预售延期，有拿到准确消息的吗？",
    excerpt: "官网写的是九月中旬出货，目前还没看到补款通知，有已经收到店家消息的朋友吗，麻烦同步一下。",
    board: "手办情报",
    author: "手办猎人",
    replies: 64,
    time: "2 小时前",
    hot: false,
  },
  {
    id: 5,
    title: "78动漫资料库怎么提交新品条目？附图文教程",
    excerpt: "很多同好不知道怎么往资料库里补录新品，这里整理了一份从提交入口到审核通过的全流程图文说明。",
    board: "站务公告",
    author: "78小编",
    replies: 23,
    time: "3 小时前",
    hot: false,
  },
  {
    id: 6,
    title: "本周二手交易避坑帖：这三家店铺评价翻车",
    excerpt: "汇总了本周交易区里被集中投诉的几家店铺，下单前记得先看评价，遇到问题也欢迎在帖子里补充。",
    board: "交易区",
    author: "老猫测评",
    replies: 97,
    time: "4 小时前",
    hot: true,
  },
];

export type QuickEntry = {
  id: number;
  icon: string;
  title: string;
  desc: string;
  badge?: string;
};

export const quickEntries: QuickEntry[] = [
  { id: 1, icon: "ri-compass-3-line", title: "模型手办选购指南", desc: "按预算、比例、厂商三步锁定目标，新手也能快速上手。", badge: "新手指南" },
  { id: 2, icon: "ri-database-2-line", title: "手办资料库", desc: "收录 12.8 万+ 条目，参数、发售、评分一眼看清。" },
  { id: 3, icon: "ri-star-smile-line", title: "周边测评", desc: "真实玩家上手，优点缺点都摊开讲，不做广告软文。" },
  { id: 4, icon: "ri-chat-smile-2-line", title: "论坛讨论区", desc: "晒物、求推荐、避坑，同好都泡在这里。" },
  { id: 5, icon: "ri-flashlight-line", title: "新品速递", desc: "每日更新预售与现货情报，抢购不再错过。" },
  { id: 6, icon: "ri-download-2-line", title: "下载 78动漫 App", desc: "扫码识款、收藏同步、到货提醒一站搞定。", badge: "热门" },
];

export type GuideStep = {
  id: number;
  step: string;
  title: string;
  desc: string;
};

export const guideSteps: GuideStep[] = [
  { id: 1, step: "01", title: "明确预算与比例", desc: "先定心理价位和摆放空间，1:7、1:6 还是非比例，直接决定可选项。" },
  { id: 2, step: "02", title: "锁定厂商与系列", desc: "不同厂商的手感与品控差异明显，认准常买的系列能少走很多弯路。" },
  { id: 3, step: "03", title: "查资料库看真实评分", desc: "在资料库对比同款的历史评价与投票数据，避开口碑翻车款。" },
  { id: 4, step: "04", title: "逛论坛看晒物与避坑", desc: "下单前翻翻晒物帖和交易区吐槽，实物图与避坑经验最有用。" },
];

export const communityStats = [
  { id: 1, value: "12.8万+", label: "收录手办条目" },
  { id: 2, value: "3.4万篇", label: "周边测评文章" },
  { id: 3, value: "86万+", label: "论坛讨论帖" },
  { id: 4, value: "210万", label: "注册同好" },
];

export const hotSearches: string[] = [
  "初音未来",
  "EVA 初号机",
  "五条悟",
  "PG 独角兽",
  "良笑社",
  "新手剪钳",
];

export type CommunityVoice = {
  id: number;
  name: string;
  tag: string;
  text: string;
  likes: number;
};

export const communityVoices: CommunityVoice[] = [
  { id: 1, name: "老猫测评", tag: "测评达人", text: "测评写多了才发现，实物图和真话比夸奖值钱得多。", likes: 268 },
  { id: 2, name: "板砖君", tag: "拼装玩家", text: "拼装最爽的不是完成那一刻，是打磨到没有一条接缝。", likes: 194 },
  { id: 3, name: "阿澈", tag: "收藏八年", text: "收藏墙满了才明白，喜欢比升值重要。", likes: 312 },
  { id: 4, name: "小新入坑", tag: "入坑两个月", text: "在论坛问了一次就被安利到钱包空空，但很值。", likes: 156 },
];

export const navItems = [
  { label: "首页", href: "#top" },
  { label: "新品速递", href: "#new-arrivals" },
  { label: "周边测评", href: "#reviews" },
  { label: "资料库", href: "#database" },
  { label: "论坛", href: "#forum" },
  { label: "下载中心", href: "#download" },
];